import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { defaultHeaderFontSize } from './constants'
import { Label } from 'irmlib/components/Controls' 

const PageHeaderContainer = styled(Label)`
  font-weight: bold;
  font-size: ${defaultHeaderFontSize};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

/**
 * PageHeader is the page header of any route page.
 *
 * @param {object} props see PageHeader.propTypes
 * @returns {React.ReactElement} - React component
 */
const PageHeader = props => {
  return ( 
    <PageHeaderContainer style={props.style} noTranslate={props.noTranslate}>
      {props.children}
    </PageHeaderContainer>
  )
}

PageHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  style: PropTypes.object,
  noTranslate: PropTypes.bool
}

export default PageHeader
